import React, { useEffect, useState } from "react";
import dayjs from "dayjs";

// i18n
import { useTranslation } from "react-i18next";

// React Icons
import { IoMdLock } from "react-icons/io";

// Contexts
import { useMasteryMap } from "../context";

// Components
import SubUnit from "./SubUnit";
import Spinner from "../../../components/spinner";

const Unit = ({ unit, index }) => {
  // Hooks
  const { t } = useTranslation();

  // Context
  const { getSubUnits, subUnitsMap } = useMasteryMap();

  // State
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getSubUnits(unit.id)
      .then(() => {
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, [unit, getSubUnits]);


  if (!unit) return null;
  const { title, start_date } = unit;
  const isLocked = dayjs().isBefore(start_date);

  const renderSubUnits = () => {
    const subUnits = subUnitsMap[unit.id];
    if (!subUnits || subUnits.length === 0) return null;

    return (
      <div className="flex flex-row gap-2 flex-wrap">
        {subUnits.map((subUnit) => (
          <SubUnit
            key={subUnit.id}
            subUnit={subUnit}
            isLocked={isLocked}
          />
        ))}
      </div>
    );
  };

  const unitLabelStyle = isLocked ? 'text-gray-500' : 'text-blue-500';
  return (
    <div className="relative flex flex-col gap-2">
      {loading && (<Spinner />)}

      <div className="flex flex-col gap-2">
        <div className="flex flex-row items-center justify-between gap-2">
          <span className={`${unitLabelStyle} text-md`}>
            {t('masteryMap.unit_label', { index: index + 1 })}
          </span>

          {isLocked && (
            <div className="flex flex-row items-center gap-2 text-sm text-gray-500">
              <IoMdLock className="text-md" />

              <span>{dayjs(unit.start_date).format('MMM D')}</span>
            </div>
          )}
        </div>

        <h1 className={`text-gray-400 text-lg`}>{title}</h1>
      </div>

      {renderSubUnits()}
    </div>
  );
};

export default Unit;
